import loadable from "@loadable/component";
import StatusIcon from "../../Icons/StatusIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import RunsheetIcon from "../../Icons/RunsheetIcon";
const RunsheetListComponent = loadable(
  () => import("../../components/Runsheet/RunsheetList")
);

const RunsheetList = () => {
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <RunsheetIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Runsheet</span>
      </div>
      <RunsheetListComponent />
    </>
  );
};

export default RunsheetList;
